/**
 * updateCheck — notice when a newer build has been deployed.
 *
 * Puzzly is a single-page app: a tab opened yesterday keeps running
 * yesterday's JavaScript however much the user navigates, because nothing ever
 * reloads index.html. A tester hit exactly that (a creator screen from before a
 * redesign, hours after it shipped). So the app compares the bundle it is
 * running with the one index.html points at now, and App reloads when that is
 * harmless (see SAFE_RELOAD_SCREENS there).
 */

const BUNDLE_RE = /static\/js\/main\.([a-z0-9]+)\.js/;

/** The content hash in a `main.<hash>.js` reference, or null. */
export function bundleHashFrom(text) {
  const m = BUNDLE_RE.exec(String(text || ""));
  return m ? m[1] : null;
}

/** The hash of the bundle this page is running, or null (e.g. the dev server). */
export function runningBundleHash(doc = typeof document !== "undefined" ? document : null) {
  if (!doc) return null;
  for (const s of Array.from(doc.scripts || [])) {
    const hash = bundleHashFrom(s.src);
    if (hash) return hash;
  }
  return null;
}

/** True when the deployed index.html points at a different bundle than ours. */
export async function isUpdateAvailable({
  fetchImpl = typeof fetch !== "undefined" ? fetch : null,
  running = runningBundleHash(),
} = {}) {
  if (!running || !fetchImpl) return false;
  const res = await fetchImpl(`/app?v=${Date.now()}`, { cache: "no-store" });
  if (!res || !res.ok) return false;
  const deployed = bundleHashFrom(await res.text());
  return !!deployed && deployed !== running;
}
